<template>
  <div class="phone-city-address">
    <div class="top">
      <div class="posRe">
        <i class="icon-img icon-back" @click="goBack"></i>
        <div class="top-search">
          <i class="icon-img icon-search" @click="searchBtn"></i>
          <i v-if="citySearchVal" class="icon-img icon-cuo-circle" @click="clearSearchBtn"></i>
          <input type="text"
                 v-model="citySearchVal"
                 placeholder="请输入城市"
                 @keyup.enter="searchBtn"
                 @input="searchInput"
                 @compositionstart="compositionstart"
                 @compositionend="compositionend"
                 @click="searchEnter"
          >
        </div>
        <template v-if="citySearchVal&&citySearchListBool">
          <div class="address-search-input-list">
            <div>
              <div class="max-con">
                <template v-if="citySearchList&&citySearchList.length">
                  <template v-for="(list,index) in citySearchList">
                    <div class="oneRow address-search-input-list-one" @click="addressTo(list,index)" :key="'addressSearchList'+index">{{list.name}}</div>
                  </template>
                </template>
                <template v-else>
                  <div>暂无相关内容</div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="city-address-content">
      <h3 class="address-title">回到{{$realmNameId==50?'重庆':'四川'}}平台</h3>
      <div class="go-index"><span @click="goIndex">{{$realmNameId==50?'重庆':'四川'}}省</span></div>
      <template v-if="addressData&&addressData.length">
        <h3 class="address-title">{{$realmNameId==50?'区县城市':'地级市'}}</h3>
        <div class="city-list-all">
          <template v-for="(one,oneIndex) in addressData">
            <div :class="[cityIndex==oneIndex?'active':'',one.state?'':'no-click']" @click="goPage(one.cityId,oneIndex,-1,one.state)" :key="'one'+oneIndex">
              <p>{{one.name}}</p>
            </div>
          </template>
        </div>
        <h3 class="address-title">{{$realmNameId==50?'乡镇城市':'区县级城市'}}</h3>
      </template>
    </div>
      <template v-if="addressData&&addressData.length">
        <div class="county-list-all">
          <div class="county-list">
            <template v-for="(item,itemIndex) in addressData">
              <div :class="['',cityActive==itemIndex?'active':'']" :key="'addressData'+itemIndex">
                <template v-if="item.child&&item.child.length">
                  <div class="county-list-title" @click="openCounty(itemIndex)">
                    {{item.name}}
                    <i class="icon-img icon-san"></i>
                  </div>
                  <div class="county-tow-list">
                    <template v-for="(itemOnly,onlyIndex) in item.child">
                      <div :class="[cityIndex==itemIndex&&countyIndex==onlyIndex?'active':'',itemOnly.state?'':'no-click']"
                           @click="goPage(itemOnly.cityId,itemIndex,onlyIndex,itemOnly.state)"
                           :key="'onlyItem'+onlyIndex">
                        <p>{{itemOnly.name}}</p>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </template>
    <popup :show-bool="popupBool" @toggle="showVal"></popup>
  </div>
</template>

<script>
// import pan from '@/components/Phone/pan'
import popup from '@/components/popup'
export default {
  name: 'phoneCityAddress',
  props: ['currentPage'],
  data () {
    return {
      citySearchVal: '',
      citySearchList: '',
      citySearchListBool: false,
      addressData: [],
      cityIndex: -1,
      countyIndex: -1,
      cityActive: -1,
      mapBool: false,
      flag: true,
      popupBool:false
    }
  },
  components:{
    popup:popup
  },
  created () {
    let that = this
    let currentParams = JSON.parse(this.publicJs.decode(that.$route.query))
    that.cityId = currentParams.cityId || 0
    that.cityIndex = currentParams.cityIndex
    that.countyIndex = currentParams.countyIndex
    that.mapBool = currentParams.mapBool
    this.httpData()
  },
  mounted () {
  },
  methods: {
    showVal:function (val) {
      this.popupBool=val;
    },
    httpData: function () {
      let that = this
      that.publicJs.addressGetData(function (res) {
        if (res.code === 1) {
          that.addressData = res.data
        }
      })
    },
    searchEnter: function () {
      this.citySearchListBool = true
    },
    compositionstart: function () {
      this.flag = false
    },
    compositionend: function () {
      this.flag = true
    },
    searchInput: function () {
      let that = this
      if (that.citySearchVal) {
        that.citySearchList = that.publicJs.fuzzyQuery(that.addressData, that.citySearchVal)
      } else {
        that.citySearchList = []
      }
    },
    addressTo: function (item) {
      let that = this
      that.citySearchListBool = false
      that.goPage(item.cityId, item.cityIndex, item.countyIndex)
    },
    searchBtn: function () {
    },
    clearSearchBtn: function () {
      this.citySearchVal = ''
    },
    goPage: function (cityId, cityIndex, countyIndex,state) {
      if(!state){
        this.popupBool=true;
        return false;
      }
      let that = this;
      if (that.currentPage === 'city') {
        this.$emit('currentParams', false);
        this.$router.push({
          path: '/phoneCity',
          query: {
            key: this.publicJs.encode(JSON.stringify({
              cityId: cityId,
              cityIndex: cityIndex,
              countyIndex: countyIndex,
              typeId: 0,
              topIndex: -1
            })),
            '_': new Date().getTime()
          }
        })
      } else {
        that.$emit('currentParams', {
          cityId: cityId,
          cityIndex: cityIndex,
          countyIndex: countyIndex
        })
      }
    },
    goIndex: function () {
      this.$router.push({
        path: '/phoneIndex'
      })
    },
    goBack: function () {
      this.$emit('currentParams', false)
    },
    openCounty: function (i) {
      let that = this
      if (that.cityActive === i) {
        that.cityActive = -1
      } else {
        that.cityActive = i
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .phone-city-address{
    position: fixed;
    top:0;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 7;
    background-color: #F2F2F2;
    overflow-y: auto;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
  .top{
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    z-index: 4;
    background-color: #248DDF;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .top>div{
    padding: 8px 12.5px 8px 52.5px;
    font-size: 8px;
    color: #FFFFFF;
    line-height: 14px;
  }
  .top-search{
    height: 28px;
    background: #FFFFFF;
    border-radius: 14px;
    padding-left: 34px;
    padding-right: 16px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }
  .icon-cuo-circle{
    position: absolute;
    right: 5px;
    top:50%;
    margin-top: -6.5px;
  }
  input::placeholder{
    color: #999999;
  }
  .top-search input{
    display: block;
    width: 100%;
    height: 100%;
    font-size: 14px;
  }
  .icon-search{
    position: absolute;
    left: 10px;
    top:4px;
  }
  .address-search-input-list{
    left: 0;
    right: 0;
  }
  .address-search-input-list>div{
    overflow-y: hidden;
    padding: 5px 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    height: 100%;
  }
  .address-search-input-list .max-con {
    height: 100%;
    overflow-y: auto;
  }
  .top .city-address{
    position: absolute;
    right: 10px;
    top:15px;
    font-size: 17px;
    color: #FFFFFF;
    padding-right:17px;
  }
  .city-address .icon-down{
    position: absolute;
    right: 0;
    top:4px;
    background-color: red;
    width: 15.5px;
    height: 8px;
    opacity: 0.6;
  }
  .city-address-content{
    padding: 38px 11px 0;
  }
  .address-title{
    font-size: 16px;
    color: #666666;
    margin-bottom: 10px;
    padding-top: 20px;
  }
  .go-index>span{
    display: block;
    width: 84.5px;
    height: 30px;
    background: #F6BC32;
    border-radius: 5px;
    font-size: 15px;
    color: #FFFFFF;
    text-align: center;
    line-height: 30px;
    letter-spacing: 1px;
  }
  .city-list-all{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin-right: -6px;
  }
  .city-list-all>div{
    padding-right: 6px;
    margin-bottom: 6px;
  }
  .city-list-all p{
    background: #FFFFFF;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 400;
    padding: 7px 21px;
  }
  .city-list-all>.active p{
    color: #248DDF;
  }
  .county-list>div{
  }
  .county-list-title{
    background-color: white;
    margin-bottom: 1px;
    position: relative;
    padding: 12px 11px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 15px;
  }
  .county-list-title i{
    position: absolute;
    right: 11px;
    top:50%;
    margin-top: -5px;
    width: 19px;
    height: 10px;
    opacity: 0.6;
    background-position: -236px -258px;
    transform: scale(0.8);
  }
  .county-tow-list{
    display: none;
    -webkit-transition: animation 0.5s;
    -moz-transition: animation 0.5s;
    -ms-transition: animation 0.5s;
    -o-transition: animation 0.5s;
    transition: animation 0.5s;
  }
  .county-tow-list>div{
    padding: 12px 11px;
    background-color: white;
    margin-bottom: 1px;
    color: #666;
    font-size: 14px;
  }
  .county-list>.active .county-tow-list{
    display: block;
    -webkit-animation: slide-down 0.3s ease-in;
    -o-animation: slide-down 0.3s ease-in;
    animation: slide-down 0.3s ease-in;
    transform-origin: top center;
  }
  .county-list>.active .county-list-title i{
    /*background-position:-270px -255px;*/
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
    transform: rotate(-180deg);
    -webkit-transition: transform 0.5s;
    -moz-transition: transform 0.5s;
    -ms-transition: transform 0.5s;
    -o-transition: transform 0.5s;
    transition: transform 0.5s;
  }
  .county-tow-list .active{
    color: #248DDF;
  }

  .no-click, .no-click:hover,
  .county-list .no-click,.county-list .no-click:hover{
    color: #c2c2c2;
    cursor: no-drop;
  }
</style>



// WEBPACK FOOTER //
// src/components/Phone/cityAddress.vue